import { useSettings } from './Settings';
import { DennemeyerRenewalOverviewProvider } from '../dennemeyer/new_way/Renewals';
import { DummyRenewalOverviewProvider } from '../dummy/Renewals';
import { PRRenewalOverviewProvider } from '../patent_renewal/Renewals';

export function RenewalOverviewProvider({ children, familyMemberId }: { familyMemberId: number; children: React.ReactNode }) {
  const { implementation } = useSettings()

  if (implementation === 'dummy') {
    return <DummyRenewalOverviewProvider {...{ familyMemberId }}>{children}</DummyRenewalOverviewProvider>
  } else if (implementation === 'dennemeyer') {
    return <DennemeyerRenewalOverviewProvider {...{ familyMemberId }}>{children}</DennemeyerRenewalOverviewProvider>
  } else if (implementation === 'patent-renewal') {
    return <PRRenewalOverviewProvider {...{ familyMemberId }}>{children}</PRRenewalOverviewProvider>
  } else {
    console.warn(`Unhandled implementation type: ${implementation}`)
    return children as JSX.Element
  }
}